import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    username: localStorage.getItem('username') || '',
    firstname: localStorage.getItem('firstname') || '',
    lastname: localStorage.getItem('lastname') || '',

    agencyNameMain: localStorage.getItem('agencyNameMain') || '',
    userId: localStorage.getItem('userid') || '',
    userProfilePic: localStorage.getItem('userProfilePic') || '',
    userProfilePicDownloadUrl:
      localStorage.getItem('userProfilePicDownloadUrl') || '',
    clientId: localStorage.getItem('clientId') || '',
    userStatus: localStorage.getItem('userStatus') || '',
    cardCurrencyName: JSON.parse(localStorage.getItem('cardCurrencyName')) || {
      value: 2,
      label: 'AUD',
      symbol: '$',
    },
    updateFieldStatus: false,
    roleName: localStorage.getItem('roleName') || 'super_admin',
    fileIdsRedux: [],
    fileDetails: localStorage.getItem('fileDetails') || '',
    isInvitee: false,
    isInviteeDirector: false,
    isInviteeTrustee:
      JSON.parse(localStorage.getItem('isInviteeTrustee')) || false,
    isBusiness: JSON.parse(localStorage.getItem('isBusiness')) || false,
    agentName: localStorage.getItem('agentName') || '',
    agencyName: localStorage.getItem('agencyName') || '',
    businessName: localStorage.getItem('businessName') || '',
    customerName: localStorage.getItem('customerName') || '',
    eddStatus: localStorage.getItem('eddStatus') || false,
    surveyStatus: localStorage.getItem('surveyStatus') || false,
    forcedPassword: localStorage.getItem('forcedPassword') || false,
    hasPendingTraining: localStorage.getItem('hasPendingTraining') || false,
    isAuthInitialized: localStorage.getItem('isAuthInitialized') || false,
    availableRoles: JSON.parse(localStorage.getItem('availableRoles')) || [],
    isBusinessOwner: localStorage.getItem('isBusinessOwner') || false,
    isback: localStorage.getItem('isBack') || false,
  },
  reducers: {
    setUsername: (state, action) => {
      localStorage.setItem('username', action.payload);
      state.username = action.payload;
    },
    setFirstName: (state, action) => {
      localStorage.setItem('firstname', action.payload);
      state.firstname = action.payload;
    },
    setLastName: (state, action) => {
      localStorage.setItem('lastname', action.payload);
      state.lastname = action.payload;
    },
    setAgencyname: (state, action) => {
      localStorage.setItem('agencyNameMain', action.payload);
      state.agencyNameMain = action.payload;
    },
    setUserIdStore: (state, action) => {
      localStorage.setItem('userid', action.payload);
      state.userId = action.payload;
    },
    setUserProfilePicDownloadUrl: (state, action) => {
      localStorage.setItem('userProfilePicDownloadUrl', action.payload);
      state.userProfilePicDownloadUrl = action.payload;
    },
    setUserProfilePic: (state, action) => {
      localStorage.setItem('userProfilePic', action.payload);
      state.userProfilePic = action.payload;
    },
    setEDDStatus: (state, action) => {
      localStorage.setItem('eddStatus', action.payload);
      state.eddStatus = action.payload;
    },
    setSurveyStatus: (state, action) => {
      localStorage.setItem('surveyStatus', action.payload);
      state.surveyStatus = action.payload;
    },
    setAvailableRoleList: (state, action) => {
      localStorage.setItem('availableRoles', JSON.stringify(action.payload)); // ✅ stringify before saving
      state.availableRoles = action.payload;
    },
    clearAvailableRoleList: (state) => {
      localStorage.removeItem('availableRoles');
      state.availableRoles = null;
    },
    setForcedPassword: (state, action) => {
      localStorage.setItem('forcedPassword', action.payload);
      state.forcedPassword = action.payload;
    },
    setIsBusinessOwner: (state, action) => {
      localStorage.setItem('isBusinessOwner', action.payload);
      state.isBusinessOwner = action.payload;
    },
    setCardCurrencyName: (state, action) => {
      localStorage.setItem('cardCurrencyName', JSON.stringify(action.payload)); // ✅ stringify before saving
      state.cardCurrencyName = action.payload;
    },
    setClientId: (state, action) => {
      localStorage.setItem('clientId', action.payload);
      state.clientId = action.payload;
    },
    clearClientId: (state) => {
      localStorage.removeItem('clientId');
      state.clientId = null;
    },

    setUserStatus: (state, action) => {
      localStorage.setItem('userStatus', action.payload);
      state.userStatus = action.payload;
    },
    setAuthInitialized: (state, action) => {
      localStorage.setItem('isAuthInitialized', action.payload);
      state.isAuthInitialized = action.payload;
    },
    clearisAuthInitialized: (state) => {
      localStorage.removeItem('isAuthInitialized');
      state.isAuthInitialized = false;
    },
    clearUserStatus: (state) => {
      localStorage.removeItem('userStatus');
      state.userStatus = null;
    },
    clearForcedPassword: (state) => {
      localStorage.removeItem('forcedPassword');
      state.forcedPassword = false;
    },
    clearCardCurrencyName: (state) => {
      localStorage.removeItem('cardCurrencyName');
      state.cardCurrencyName = null;
    },
    clearUsername: (state) => {
      localStorage.removeItem('username');
      state.username = null;
    },
    clearFirstName: (state) => {
      localStorage.removeItem('firstname');
      state.firstname = null;
    },
    clearLastName: (state) => {
      localStorage.removeItem('lastname');
      state.lastname = null;
    },
    clearAgencyname: (state) => {
      localStorage.removeItem('agencyNameMain');
      state.agencyNameMain = null;
    },
    clearUserProfilePicDownloadUrl: (state) => {
      localStorage.removeItem('userProfilePicDownloadUrl');
      state.userProfilePicDownloadUrl = null;
    },
    clearUserId: (state) => {
      localStorage.removeItem('userid');
      state.userId = null;
    },
    clearUserProfilePic: (state) => {
      localStorage.removeItem('userProfilePic');
      state.userProfilePic = null;
    },
    UpdateFieldStatusTrue: (state, action) => {
      state.updateFieldStatus = true;
    },
    UpdateFieldStatusFalse: (state) => {
      state.updateFieldStatus = false;
    },
    setRoleName: (state, action) => {
      localStorage.setItem('roleName', action.payload);
      state.roleName = action.payload;
    },
    clearRoleName: (state) => {
      localStorage.removeItem('roleName');
      state.roleName = null;
    },
    setFileIdsRedux: (state, action) => {
      state.fileIdsRedux = action.payload;
    },
    clearFileIdsRedux: (state) => {
      state.fileIdsRedux = [];
    },
    setFileDetails: (state, action) => {
      localStorage.setItem('fileDetails', action.payload);
      state.fileDetails = action.payload;
    },
    clearFileDetails: (state) => {
      localStorage.removeItem('fileDetails');
      state.fileDetails = '';
    },
    setIsInvitee: (state, action) => {
      localStorage.setItem('isInvitee', JSON.stringify(action.payload));
      state.isInvitee = action.payload;
    },
    clearIsInvitee: (state) => {
      localStorage.removeItem('isInvitee');
      state.isInvitee = '';
    },
    setIsInviteeTrustee: (state, action) => {
      localStorage.setItem('isInviteeTrustee', JSON.stringify(action.payload));
      state.isInviteeTrustee = action.payload;
    },
    setIsInviteeDirector: (state, action) => {
      localStorage.setItem('isInviteeDirector', JSON.stringify(action.payload));
      state.isInviteeDirector = action.payload;
    },
    setIsBack: (state, action) => {
      localStorage.setItem('isback', JSON.stringify(action.payload));
      state.isback = action.payload;
    },
    clearIsBack: (state) => {
      localStorage.removeItem('isback');
      state.isback = false;
    },
    clearIsInviteeDirector: (state) => {
      localStorage.removeItem('isInviteeDirector');
      state.isInviteeDirector = '';
    },
    clearIsInviteeTrustee: (state) => {
      localStorage.removeItem('isInviteeTrustee');
      state.isInviteeTrustee = '';
    },
    setPendingTraining: (state, action) => {
      localStorage.setItem(
        'hasPendingTraining',
        JSON.stringify(action.payload),
      );
      state.hasPendingTraining = action.payload;
    },
    clearPendingTraining: (state) => {
      localStorage.removeItem('hasPendingTraining');
      state.hasPendingTraining = false;
    },

    setIsBusiness: (state, action) => {
      localStorage.setItem('isBusiness', JSON.stringify(action.payload));
      state.isBusiness = action.payload;
    },
    clearIsBusiness: (state) => {
      localStorage.removeItem('isBusiness');
      state.isBusiness = '';
    },
    setAgentNameRedux: (state, action) => {
      localStorage.setItem('agentName', action.payload);
      state.agentName = action.payload;
    },
    clearAgentName: (state) => {
      localStorage.removeItem('agentName');
      state.agentName = null;
    },
    clearCustomerName: (state) => {
      localStorage.removeItem('customerName');
      state.customerName = null;
    },
    setCustomerNameRedux: (state, action) => {
      localStorage.setItem('customerName', action.payload);
      state.customerName = action.payload;
    },
    setAgencyNameRedux: (state, action) => {
      localStorage.setItem('agencyName', action.payload);
      state.agencyName = action.payload;
    },
    setBusinessNameRedux: (state, action) => {
      localStorage.setItem('businessName', action.payload);
      state.businessName = action.payload;
    },
    clearAgencyName: (state) => {
      localStorage.removeItem('agencyName');
      state.agencyName = null;
    },
    clearEddStatus: (state) => {
      localStorage.removeItem('eddStatus');
      state.eddStatus = false;
    },
    clearSurveyStatus: (state) => {
      localStorage.removeItem('surveyStatus');
      state.surveyStatus = false;
    },
    clearBusinessName: (state) => {
      localStorage.removeItem('businessName');
      state.businessName = null;
    },
    clearIsBusinessOwner: (state) => {
      localStorage.removeItem('isBusinessOwner');
      state.isBusinessOwner = false;
    },
  },
});

export const {
  setUsername,
  clearUsername,
  setUserIdStore,
  clearUserId,
  setUserProfilePic,
  clearUserProfilePic,
  clearUserProfilePicDownloadUrl,
  setUserProfilePicDownloadUrl,
  setCardCurrencyName,
  clearCardCurrencyName,
  setClientId,
  clearClientId,
  UpdateFieldStatusFalse,
  UpdateFieldStatusTrue,
  setRoleName,
  clearRoleName,
  setFileIdsRedux,
  clearFileIdsRedux,
  setFileDetails,
  clearFileDetails,
  setIsInvitee,
  clearIsInvitee,
  setUserStatus,
  clearUserStatus,
  setIsInviteeDirector,
  clearIsInviteeDirector,
  setIsInviteeTrustee,
  clearIsInviteeTrustee,
  setIsBusiness,
  clearIsBusiness,
  setAgentNameRedux,
  clearAgentName,
  setCustomerNameRedux,
  clearCustomerName,
  setBusinessNameRedux,
  clearBusinessName,
  setAgencyNameRedux,
  clearAgencyName,
  setEDDStatus,
  clearEddStatus,
  setSurveyStatus,
  setAuthInitialized,
  clearisAuthInitialized,
  setIsBack,
  clearIsBack,
  setAgencyname,
  clearAgencyname,
  clearSurveyStatus,
  setForcedPassword,
  clearForcedPassword,
  setPendingTraining,
  clearPendingTraining,
  setAvailableRoleList,
  clearAvailableRoleList,
  setIsBusinessOwner,
  ClearIsBusinessOwner,
  setFirstName,
  clearFirstName,
  setLastName,
  clearLastName,
} = userSlice.actions;
export default userSlice.reducer;
